// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"96981317","239":"8b6fcb27","455":"f10a2a6f","533":"1b3d9c10","557":"a9e8c7a1","762":"48ffce08"}[chunkId] + ".chunk.js";
};